import { XCFormField, XCForm } from "@robe/core-types";

export const mapFormFields = (form: XCForm[]) => {
  const fields: XCFormField[] = [];

  form.forEach((f) => f?.rows?.forEach((rY) => rY.forEach((rX) => fields.push(rX))));

  return fields;
};
